import React from 'react';
import { motion } from 'framer-motion';
import { Train, Building2, Building, Star } from 'lucide-react';

const references = [
  {
    Icon: Train,
    name: 'Deutsche Bahn',
    tag: 'Infrastruktur',
    desc: 'Hochwertige Textil- und Raumausstattungslösungen für Betriebsbereiche der Deutschen Bahn.',
  },
  {
    Icon: Building2,
    name: 'Südafrikanische Botschaft Berlin',
    tag: 'Diplomatisches Corps',
    desc: 'Repräsentative Gardinen- und Innenausstattung für die südafrikanische Botschaft in Berlin.',
  },
  {
    Icon: Building,
    name: 'Australische Botschaft Berlin',
    tag: 'Diplomatisches Corps',
    desc: 'Maßgefertigte Raumausstattung für die australische Botschaft — elegant und funktional.',
  },
  {
    Icon: Star,
    name: 'Hotels & Arztpraxen',
    tag: 'Hotellerie & Medizin',
    desc: 'Mehrere bekannte Berliner Hotels, Arztpraxen und Physiotherapien vertrauen unserer Handwerkskunst.',
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};
const itemVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.65, ease: 'easeOut' } },
};

const References = () => (
  <section
    id="referenzen"
    data-testid="references-section"
    className="py-28 bg-white"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="text-center mb-18"
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
      >
        <span className="text-[11px] tracking-[0.22em] uppercase text-[#8B7355] font-outfit mb-3 block">
          Referenzen
        </span>
        <h2 className="font-cormorant text-4xl md:text-5xl text-[#2A2A2A] mb-5 font-medium">
          Vertrauen, das zählt.
        </h2>
        <p className="font-outfit text-base text-[#2A2A2A]/65 max-w-xl mx-auto leading-relaxed">
          Von Berliner Privatkunden bis zur Botschaft — wir setzen jedes Projekt mit derselben Sorgfalt um.
        </p>
      </motion.div>

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        {references.map((ref, i) => (
          <motion.div
            key={i}
            variants={itemVariants}
            data-testid={`reference-card-${i}`}
            className="bg-[#F8F5F0] border border-[#EDE8E0] p-8 flex flex-col items-center text-center group hover:border-[#8B7355] hover:bg-white transition-all duration-300 cursor-default"
          >
            <div className="w-14 h-14 rounded-full bg-white border border-[#EDE8E0] flex items-center justify-center mb-5 group-hover:bg-[#8B7355] transition-colors duration-300">
              <ref.Icon
                size={20}
                className="text-[#C4944A] group-hover:text-white transition-colors duration-300"
              />
            </div>
            <span className="text-[10px] tracking-[0.2em] uppercase text-[#8B7355] font-outfit mb-2.5">
              {ref.tag}
            </span>
            <h3 className="font-cormorant text-xl text-[#2A2A2A] mb-3 font-semibold leading-snug">
              {ref.name}
            </h3>
            <p className="font-outfit text-sm text-[#2A2A2A]/60 leading-relaxed">
              {ref.desc}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default References;
